import { getEl, getSelector } from '../../wordpress/helpers/helpers';
import { breakpoints } from '../../wordpress/globals/config';

(function(){

    const relatedTopicsMain     = getEl('related-topics-main');
    const mainDropDown          = getEl('related-topics-main-dropdown');
    const ulList                = getEl('related-topics-ul-list');
    const isSingle              = getSelector('.single.single-post');
    const sectionSubMenu        = document.querySelectorAll('.section-landing-page .c-Article-accordian-menu-wrap a.inner-nav');    

    //animations classes
    const displaySubmenuClass   = 'c-Article-submenu-wrap--display';
    const displayMainWrap       = 'c-Article-accordian-menu-wrap--display';
    const rotateArrowClass      = 'c-Article-rotate-arrow';
    const menuShadowClass       = 'c-Article-add-shadow';
    const sideMenu              = '.c-menu .c-Article__side-menu-item a';
    const sideMenuActive        = '.c-menu .c-Article__side-menu-item .active';
    let sideMenuTitle         = document.querySelectorAll('.c-Article-accordian-title-wrap');
    const sideMenuOptions       = '.c-Article-accordian-menu-wrap';

    if(sideMenuTitle) {
        sideMenuTitle = Array.from(sideMenuTitle);
        sideMenuTitle.forEach(element => {
            element.addEventListener('click', (e) => toggleMainMenus(e) );
        })
    }

    if(ulList) {
        ulList.addEventListener('click', e => {
            let nextSibling = e.target.nextElementSibling;
            //if click event target is a subheading, make next sibling show
            if(e.target && e.target.classList.contains('c-Article-menu-item') === true && nextSibling) {
    
                if(nextSibling.classList.contains(displaySubmenuClass)) {
                    e.target.classList.remove(rotateArrowClass);
                    nextSibling.classList.remove(displaySubmenuClass);
                } else if(nextSibling.classList.contains('c-Article-submenu-wrap')){
                    e.target.classList.add(rotateArrowClass);
                    nextSibling.classList.add(displaySubmenuClass);
                    removeOtherLiClass(nextSibling);
                }
    
            }
        });
    }

    Array.prototype.forEach.call(sectionSubMenu, e => {
        e.addEventListener('click', (e) => {
            let $subMenu = document.querySelector('#related-topics-main-dropdown');
            $subMenu.classList.remove(menuShadowClass);
            $subMenu.classList.remove(displayMainWrap);

            let $subMenu2 = document.querySelector('#related-topics-main');
            $subMenu2.classList.remove(rotateArrowClass);
            $subMenu2.classList.remove(menuShadowClass);
        });
    });


    const toggleMainMenus = elm => {

        const current_elm = elm.currentTarget;
        const drp_elem = elm.currentTarget.nextElementSibling;
        const body_elem = document.querySelector('body');
        const forceOpen = false;
        const open = () => {
            removeAll();
            body_elem.addEventListener('click', windowEvent);
            drp_elem.classList.add(displayMainWrap);
            drp_elem.classList.add(menuShadowClass);
            current_elm.classList.add(rotateArrowClass);
            current_elm.classList.add(menuShadowClass);
        }

        const remove = () => {
            body_elem.removeEventListener('click', windowEvent);
            drp_elem.classList.remove(displayMainWrap);
            drp_elem.classList.remove(menuShadowClass);
            current_elm.classList.remove(rotateArrowClass);
            current_elm.classList.remove(menuShadowClass);
        }

        const removeAll = () => {
            body_elem.removeEventListener('click', windowEvent);            
            Array.prototype.forEach.call(sideMenuTitle, elem => {
                elem.classList.remove(rotateArrowClass);
                elem.classList.remove(menuShadowClass);
                elem.nextElementSibling.classList.remove(displayMainWrap);
                elem.nextElementSibling.classList.remove(menuShadowClass);
            });
        }

        const windowEvent = (e) => {            
            if (e.target.closest('.c-Article-accordian-main-wrap') == null) {
                removeAll();
            }            
        }

       if(!current_elm.classList.contains(rotateArrowClass)) { 
            open();
        } else if(!forceOpen) {
            remove();
        }

    }

    const removeOtherLiClass = clsToKeep => {
        const allSubmenus = document.getElementsByClassName('c-Article-submenu-wrap');
        Array.prototype.forEach.call(allSubmenus, x => {
            if(x !== clsToKeep) {
                x.classList.remove(displaySubmenuClass);
                x.previousElementSibling.classList.remove(rotateArrowClass);
            }
        });
    }

    //const checkIfSmallForToggle = () => window.innerWidth < breakpoints.small ? toggleMain(true) : toggleMain(false);

    /**
     * set the width of side menu per the largest title
     */

    let $sideMenus = document.querySelectorAll(sideMenu);
    let $sideActiveMenus = document.querySelectorAll(sideMenuActive);
    $sideMenus = [...$sideMenus];
    $sideActiveMenus = [...$sideActiveMenus];

    let getAllWidths = $sideMenus.map((menu)=>menu.offsetWidth);
    let getAllActiveWidths = $sideActiveMenus.map((menu) => menu.offsetWidth);
    let getATagMax = getAllWidths && getAllWidths.length ? Math.max(...getAllWidths) : 0;
    let getActiveMax = getAllActiveWidths && getAllActiveWidths.length ? Math.max(...getAllActiveWidths) : 0;
    
    if (getActiveMax && !isNaN(getActiveMax) && getATagMax && !isNaN(getATagMax)) {
        let widthOfContainer = Math.max(getATagMax, getActiveMax) + 20;
        
        if (widthOfContainer > 280) {
            document.querySelector(".c-Article-sides-wrap.c-menu").style.width = widthOfContainer + 'px';
            document.querySelector(".c-Article-sides-wrap.c-menu").classList.add('c-menu--font');
        }
    }


    /*
    * Inline ads block auto height adjustment.
    */
    let allBlocks   = document.querySelectorAll(".o-Adv-block__item.o-Adv-block__item--two") || [];
    let timeout     = false;
    const delay     = 150;
    const calls     = 0;
            
    function getDimensions() {
        Array.prototype.forEach.call(allBlocks, e => e.removeAttribute('style')); // Removing the style height before calculating the heights of the adblock.
        if (allBlocks) {
            allBlocks = Array.from(allBlocks);
        } else {
            allBlocks = [];
        }
        let heights     = allBlocks.map(e=>e.offsetHeight);
        let maxHeight   = Math.max(...heights);

        Array.prototype.forEach.call(allBlocks, e => e.style.height = maxHeight + 'px');
    }
    
    window.addEventListener('resize', function() {

      clearTimeout(timeout);

      timeout = setTimeout(getDimensions, delay);
    });

    getDimensions();

    // Currency Conversion

    // Expected cc-usa on the page.
    let $conversionValue = document.querySelector('.cc-usa') || [];
    let $tableElem = document.querySelectorAll('.cc-usd tbody tr');
    let $inlineElem = document.querySelectorAll('.cc-usd.inline-conversion');
    
    if ($conversionValue && $tableElem) {
                
        // Expecting which country currency is there in the page to get converted with USD.
        let currencyType = Array.from($conversionValue.classList || []);
        currencyType = currencyType.length > 1 && currencyType[1] ? currencyType[1] : '';
        // Read the table to get converted.
        let $currencyTable = [...$tableElem];
        let thisConversionValue;

        switch (currencyType) {
            case 'ctype-ind':

                // Read value from script.
                thisConversionValue = + window.immiObj.currency["Indian Rupee"];

                // Set the value to span element
                $conversionValue.innerText = thisConversionValue;

                // Traverse through the array
                $currencyTable.forEach((e)=>{
                    let usdValue = + [...e.children][1].innerText.replace(/[$\s,]/g,'').trim();
                    if (usdValue !== 'NaN') {
                        [...e.children][2].innerText = 'Rs. ' + (usdValue * thisConversionValue).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 } );
                    }
                });
                break;
            case 'ctype-zh':
                // Read value from script.
                thisConversionValue = + window.immiObj.currency["Chinese Yuan"];

                // Set the value to span element
                $conversionValue.innerText = thisConversionValue;

                // Traverse through the array
                $currencyTable.forEach((e) => {
                    let usdValue = +[...e.children][1].innerText.replace(/[$\s,]/g, '').trim();
                    if (usdValue !== 'NaN') {
                        [...e.children][2].innerText = 'RMB. ' + (usdValue * thisConversionValue).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 } );
                    }
                });
                break;
            case 'ctype-mx':
                // Read value from script.
                thisConversionValue = + window.immiObj.currency["Mexican Peso"];

                // Set the value to span element
                $conversionValue.innerText = thisConversionValue;

                // Traverse through the array
                $currencyTable.forEach((e) => {
                    let usdValue = +[...e.children][1].innerText.replace(/[$\s,]/g, '').trim();
                    if (usdValue !== 'NaN') {
                        [...e.children][2].innerText = (usdValue * thisConversionValue).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 } );
                    }
                });
                break;
            case 'ctype-br':
                // Read value from script.
                thisConversionValue = + window.immiObj.currency["Brazilian Real"];

                // Set the value to span element
                $conversionValue.innerText = thisConversionValue;

                // Traverse through the array
                $currencyTable.forEach((e) => {
                    let usdValue = +[...e.children][1].innerText.replace(/[$\s,]/g, '').trim();
                    if (usdValue !== 'NaN') {
                        [...e.children][2].innerText = 'R$' + (usdValue * thisConversionValue).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 } );
                    }
                });
                break;
        }
        
    }

    if ($conversionValue && $inlineElem) {
        $inlineElem = Array.from($inlineElem);
        $inlineElem.forEach((e)=>{
            let usdValue = + e.getAttribute('cc-value');
            let ccType = e.getAttribute('cc-type');
            let thisConversionValue;

            switch (ccType) {
                case 'ind':
                // Read value from script.
                thisConversionValue = + window.immiObj.currency["Indian Rupee"];

                // Set the value to span element
                $conversionValue.innerText = thisConversionValue;

                e.innerText = 'Rs. ' + (usdValue * thisConversionValue).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 } );

                break;
                case 'zh':
                // Read value from script.
                thisConversionValue = +window.immiObj.currency["Chinese Yuan"];

                // Set the value to span element
                $conversionValue.innerText = thisConversionValue;

                e.innerText = 'RMB. ' + (usdValue * thisConversionValue).toLocaleString(undefined, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2
                });

                break;
                case 'mx':
                // Read value from script.
                thisConversionValue = +window.immiObj.currency["Mexican Peso"];

                // Set the value to span element
                $conversionValue.innerText = thisConversionValue;

                e.innerText = (usdValue * thisConversionValue).toLocaleString(undefined, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2
                });

                break;
                case 'br':
                // Read value from script.
                thisConversionValue = +window.immiObj.currency["Brazilian Real"];

                // Set the value to span element
                $conversionValue.innerText = thisConversionValue;

                e.innerText = 'R$' + (usdValue * thisConversionValue).toLocaleString(undefined, {
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2
                });

                break;

            }
        });
    }


    // Left Sidebar sticky Advertisement div
    const $sideMenu = document.querySelector('.c-Article-sides-wrap.c-menu > div');
    const $sideSqAdv = document.querySelector('.c-Article__side-adv');
    const $article = document.querySelector('#content article');
    let debounceTimeout = null;
    if ($sideMenu && $sideMenu.scrollHeight < $article.scrollHeight) {
        window.immiObj.sideAdvOffset = $sideMenu.offsetTop;
        window.immiObj.sideAdvOffsetHeight = $sideMenu.offsetHeight + 10;    
        if ($sideSqAdv) window.immiObj.sideAdvHeight = $sideSqAdv.offsetHeight;
        if (typeof window.scrollY === "number") {
            window.addEventListener('scroll', function () {
                debounce(executeStickyFn, 15)
            } );
        }
    }

    function debounce (fn, timmer) {
        clearTimeout(debounceTimeout);
        debounceTimeout = setTimeout(() => {
            fn();
        }, timmer);
    }

    function executeStickyFn () {
        let $sideAdv = document.querySelector('.c-Article-sides-wrap.c-menu');
        let $stickyAdv = document.querySelector('.c-Sticky-adv');
        let sideAdvOffset = (window.immiObj.sideAdvOffset + window.immiObj.sideAdvOffsetHeight) - window.immiObj.sideAdvHeight;
        let scrollY = window.scrollY;                
        if (scrollY >= sideAdvOffset && window.innerWidth > 991) {
            $sideAdv.classList.add('c-Sticky-adv');
            // $stickyAdv.classList.add('sticky');                    
            // $stickyAdv.style.width = '240px';
            // $sideAdv.style.display = "none";
        } else if (window.innerWidth > 991) {
            $sideAdv.classList.remove('c-Sticky-adv');
            // $stickyAdv.classList.remove('sticky');
            // $sideAdv.style.display = "block";
        }
    }

    window.addEventListener('resize', function () {
        if($sideMenu) {
            let windowWidth = window.innerWidth;
            if(windowWidth < 992) {
                document.querySelector('.c-Sticky-adv').classList.remove('sticky');
                document.querySelector('.c-Article-sides-wrap.c-menu').style.display = "";
            }
        }
    });

    // Add page view count on page load.
    if (isSingle) {
        let postid;
        if (isSingle.classList) {
            postid = Array.from(isSingle.classList).filter(item=>item.indexOf('postid')>-1);
            if (postid && postid.length) postid = postid[0].replace(/postid-/g,'');
            else postid = null
        }
        const formData = new FormData();
        formData.append('action', 'immi_register_view');
        if (postid) formData.append('postId', postid);
        let request = new XMLHttpRequest();
        request.open('POST', window.immiObj.viewPostLink);
        request.send(formData);
        request.onreadystatechange = function() {
            if (request && request.responseText) {
                const $elm = document.querySelector(".view-count");
                if ($elm) $elm.innerText = parseInt(request.responseText).toLocaleString();
            }
        }

    }


})();